import React from 'react';
import { PinnacleChipProps } from './PinnacleChip.types';
import StyledPinnacleChip from './PinnacleChip.styled';

const PinnacleChip: React.FC<PinnacleChipProps> = (props) => (
  <StyledPinnacleChip {...props} />
);

export default PinnacleChip;
